import styled from "styled-components";

export const BalanceContainer = styled.div`
  width: 100%;
  height: auto;
  flex-shrink: 0;
  display: flex;
  flex-direction: row;
  gap: 20px;

  @media only screen and (max-width: 767px) {
    display: flex;
    flex-direction: row;
    overflow-y: auto;
  }
`;
export const CompleteContainer = styled.div`
  width: 100%;
  /* height: 265px; */
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  margin-bottom: 20px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
  display: none;
  @media only screen and (max-width: 767px) {
    /* width: 20.4375rem; */
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
  }
`;
export const OurProductContainer = styled.div`
  // // width: 100%;
  /* height: 632px; */
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
  margin-bottom: 20px;
  padding: 0px;

  @media only screen and (max-width: 767px) {
    padding-left: 10px;
  }
  // width: 100%;
  // height: auto;
  // flex-shrink: 0;
  // display: flex;
  // flex-direction: row;
  // gap: 20px;
  // background: purple;

  // @media only screen and (max-width: 767px) {
  //   display: flex;
  //   flex-direction: row;
  //    overflow-y: auto;
  //    background: purple;
  // }
`;

export const ChatContainer = styled.div`
  width: 100%;
  /* height: 893px; */
  height: auto;
  flex-shrink: 0;
  border-radius: 10px;
  border: 1px solid var(--General-Stroke, #e8eaed);
  background: var(--General-White, #fff);
  box-shadow: 0px 4px 4px 0px rgba(234, 234, 234, 0.25);
  margin-bottom: 20px;
`;
